//@flow
import React from "react"
import { connect } from "react-redux"
import { replace, push } from "react-router-redux"
import { compose } from "react-apollo"
import { Helmet } from "react-helmet"
import {
  EntityHeading,
  EntityDetail,
  Entity,
  EntityAction,
  EntityPrimaryLink
} from "../UI/EntityList"
import { parseQueryString } from "../RoutingHelpers"
import { SearchTableView } from "../SearchTableView"
import queries from "./queries"
import type { SensorListViewProps } from "./types"

type State = { mutationLoading: boolean }

class SensorListView extends React.Component<SensorListViewProps, State> {
  constructor(props) {
    super(props)
    this.state = { mutationLoading: false }
  }

  render() {
    const {
      sensors: { sensors, loading },
      match,
      replace,
      searchName,
      history: { push }
    } = this.props
    const count = sensors ? sensors.length : 0
    return (
      <SearchTableView
        url={match.url}
        routerAction={replace}
        entityName="Sensors"
        searchName={searchName}
        loading={loading || this.state.mutationLoading}
      >
        <Helmet>
          <title>
            {`${count} Sensor${count === 1 ? "" : "s"}${searchName !== ""
              ? ` Matching '${searchName}'`
              : ""}`}
          </title>
        </Helmet>
        <EntityHeading>
          <EntityDetail grow={2}>Name</EntityDetail>
          <EntityDetail grow={1}>Serial</EntityDetail>
          <EntityDetail grow={1}>Coordinates</EntityDetail>
          <EntityDetail grow={1} shrink={0} />
        </EntityHeading>
        {sensors &&
          sensors.map(sensor => (
            <Entity key={sensor.id}>
              <EntityDetail grow={2}>
                <EntityPrimaryLink to={`${match.url}/${sensor.id}`}>
                  {sensor.friendlyName || sensor.stationName}
                </EntityPrimaryLink>
              </EntityDetail>
              <EntityDetail grow={1}>{sensor.serialNumber}</EntityDetail>
              <EntityDetail grow={1}>
                {sensor.latitude}, {sensor.longitude}
              </EntityDetail>
              <EntityDetail grow={1} shrink={0} row end>
                <EntityAction
                  href="#"
                  onClick={() => push(`${match.url}/${sensor.id}`)}
                  icon="✏️"
                />
              </EntityDetail>
            </Entity>
          ))}
      </SearchTableView>
    )
  }
}

const SensorsWithData = compose(queries.withSensors)(SensorListView)

export default connect(
  state => ({
    searchName: parseQueryString(state, "name")
  }),
  {
    replace,
    push
  }
)(SensorsWithData)



// WEBPACK FOOTER //
// ./src/Sensors/SensorListView.js